import { render, staticRenderFns } from "./AssessmentForm.vue?vue&type=template&id=50ce5ea3&scoped=true"
import script from "./AssessmentForm.vue?vue&type=script&lang=js"
export * from "./AssessmentForm.vue?vue&type=script&lang=js"
import style0 from "./AssessmentForm.vue?vue&type=style&index=0&id=50ce5ea3&prod&lang=scss"
import style1 from "./AssessmentForm.vue?vue&type=style&index=1&id=50ce5ea3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce5ea3",
  null
  
)

export default component.exports